import { update } from '@/api/rest';

const projectUdc = {
  saveUdcIdList: async (id, data) =>
    await update(`/project-udc/save-udc-id-list/${id}`, data),
};
export default projectUdc;
